<template>
    <div id="app" @contextmenu.prevent >
            <div>
                <el-image
                        :src="imgUrl"
                >
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>

                </el-image>
            </div>
    </div>

</template>

<script>
    import {imageUrl} from '../api/api';
   /* var PDFJS = require('pdfjs-dist');*/
    //import PDFJS from 'pdfjs-dist/build/pdf.js';
    //PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.js');

    export default {
        name: "attachmentView",
        data() {
            return {
                path: "",
                count:0,
                totalPage:0,
                currentPage:0,
                pdf:"",
                pager:{
                    page:1,
                    size:1,
                    total:0
                },
                imgUrl:"",
                count:0
            }
        },
        methods: {
            getImg(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if(this.count==1){
                    this.imgUrl =  imageUrl(this.$route.query.path);
                    this.count=0;
                    loading.close();
                    return;
                }
                if (this.count < 1) {
                    this.count++;
                    setTimeout(this.getImg, 1000);
                }
            }
        },
            mounted() {
                //http://localhost:9290/Path/overseaAdminFees/20190610160013微信图片_20190610155733.jpg
                this.getImg();
            },
            watch: {
            },
        components:{

        },
    }
</script>

<style scoped>

    .bottom_line {
        width: 100%;
        background-color: white;
        position: fixed;
        bottom: 0;
        border: 2px ridge #e68916;
    }
</style>


// WEBPACK FOOTER //
// src/views/PicView.vue